import axiosInstance from './axios';

export const orderService = {
  getOrders: async (params = {}) => {
    const response = await axiosInstance.get('/orders', { params });
    return response.data;
  },

  getOrder: async (id) => {
    const response = await axiosInstance.get(`/orders/${id}`);
    return response.data;
  },

  createOrder: async (orderData) => {
    const response = await axiosInstance.post('/orders', orderData);
    return response.data;
  },

  updateOrder: async (id, orderData) => {
    const response = await axiosInstance.put(`/orders/${id}`, orderData);
    return response.data;
  },

  deleteOrder: async (id) => {
    const response = await axiosInstance.delete(`/orders/${id}`);
    return response.data;
  },

  getOrderStatistics: async () => {
    const response = await axiosInstance.get('/orders/statistics');
    return response.data;
  },

  downloadInvoice: async (id) => {
    const response = await axiosInstance.get(`/orders/${id}/invoice`, {
      responseType: 'blob',
    });
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Facture_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return response.data;
  },

  // Bon de commande (BC) — the client-facing order confirmation.
  downloadBonCommande: async (id) => {
    const response = await axiosInstance.get(`/orders/${id}/bon-commande`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `BC_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return response.data;
  },

  updateOrderStatus: async (id, status, notes = null) => {
    const payload = { status };
    if (notes) {
      payload.notes = notes;
    }
    const response = await axiosInstance.post(`/orders/${id}/update-status`, payload);
    return response.data;
  },

  cancelOrder: async (id) => {
    const response = await axiosInstance.post(`/orders/${id}/cancel`);
    return response.data;
  },
};
